import { render, staticRenderFns } from "./vendorBankDetailsDashboard.vue?vue&type=template&id=04da4243&scoped=true&"
import script from "./vendorBankDetailsDashboard.vue?vue&type=script&lang=js&"
export * from "./vendorBankDetailsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04da4243",
  null
  
)

export default component.exports